<script lang="ts">import { page } from "$app/stores";
import { cfgToThemeContentPath } from "@infinitro/config";
import { locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { fetchLocaleMarkdownWithEnFallback } from "./fetch-markdown-seo";
export let showMoreButton = true;
$: providerSlug = $page.params.provider ?? "";
let htmlContent = "";
let lastModified = "";
$: if ($loggedIn === false && providerSlug) {
	const p = providerSlug;
	const loc = $locale;
	fetchLocaleMarkdownWithEnFallback(cfgToThemeContentPath(`/seo/providers/${p}/${p}.${loc}.md`), cfgToThemeContentPath(`/seo/providers/${p}/${p}.en.md`)).then(({ html, lastModified: lm }) => {
		if ($loggedIn !== false || p !== $page.params.provider || loc !== $locale) return;
		htmlContent = html;
		lastModified = lm;
	});
} else {
	htmlContent = "";
	lastModified = "";
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

<CdnSeoMarkdownPanel noContainer {htmlContent} {lastModified} {showMoreButton} />
